import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { StorageService } from "../../services/storage.service";
import { AppLogo1 } from "../../app.config";

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/registered-vendors",
    title: "Registered Vendors",
    icon: "../../../assets/img/icons/common/registered-vendor.svg",
    class: "",
  },
  {
    path: "/add-new-vendor",
    title: "Add New Vendor",
    icon: "../../../assets/img/icons/common/add-new-vendor.svg",
    class: "",
  },
];

@Component({
  selector: "app-super-admin-sidebar",
  templateUrl: "./super-admin-sidebar.component.html",
  styleUrls: ["./super-admin-sidebar.component.scss"],
})
export class SuperAdminSidebarComponent implements OnInit {
  public menuItems: any[];
  public isCollapsed = true;
  appLogo = AppLogo1;

  constructor(private storageService: StorageService, private router: Router) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }
}
